import HumanTimeSince from "components/HumanTimeSince"
import PropTypes from "prop-types"
import React from "react"
import { Grid, Image } from "semantic-ui-react"
const ConnectedAccountBar = ({ image_url, description, style, updated_at }) => (
  <Grid textAlign="left" style={{ background: "#FAFAFA", ...style }}>
    <Grid.Row columns="equal">
      <Grid.Column width={2} verticalAlign="middle">
        <Image src={image_url} />
      </Grid.Column>
      <Grid.Column>
        <p className="greyed-text" style={{ fontWeight: "bold" }}>
          LINKED ACCOUNT
        </p>
        <p>{description}</p>
      </Grid.Column>
      <Grid.Column textAlign="right">
        <p className="greyed-text">
          Refreshed <HumanTimeSince time={updated_at} /> ago
        </p>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

ConnectedAccountBar.propTypes = {
  image_url: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default ConnectedAccountBar
